import { format } from "date-fns";
import { TrainInfoMessage } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/types/trainInformationAggregated";
import { FC, useMemo } from "react";
import { Alert, Text } from "shared/components/Spor";

type GroupTravelStaticAlertProps = {
  event: TrainInfoMessage;
};

export const GroupTravelStaticAlert: FC<GroupTravelStaticAlertProps> = ({
  event,
}) => {
  const updatedAt = useMemo(
    () => format(new Date(event.updatedAt), "HH:mm (dd.MM.yy)"),
    [event.updatedAt],
  );

  return (
    <Alert data-color="info" title="Gruppereise">
      <Text>{event.message}</Text>
      <Text fontStyle="italic">Sist oppdatert: {updatedAt}</Text>
    </Alert>
  );
};
